import { ExceptionTypes, BizCodes } from "./consts";

export { WWW_SOURCE_TYPE as SOURCE_TYPE } from "./consts";

const sendOwlAjaxError = window.sendOwlAjaxError || (() => null);

/**
 * 简单的 cache in memory
 * @param {Function} caller
 * @returns {Function}
 */
export function onceOnlyInMemory(caller) {
  const memory = {};
  return function(id) {
    if (!(id in memory)) memory[id] = Promise.resolve(caller(id));
    return memory[id];
  };
}

function nameError(err, name) {
  err.name = name; // eslint-disable-line
  return err;
}

function _bizError(response, message) {
  const err = new Error(response.body.message || message);
  err.response = response;
  err.bizCode = response.body.status;
  return nameError(err, ExceptionTypes.BizError);
}

/**
 * 新的 gateway superagent wrapper
 * @param sa
 * @returns {Promise<any>}
 */
export function afterGateway(sa) {
  /* abort 不会进入 .then ，如有需求，需要额外处理 */
  const result = sa
    .then(null, err => {
      if (!err) throw nameError(new Error("不明异常"), ExceptionTypes.NullError);
      err.rawMessage = err.message; // eslint-disable-line
      if (err.timeout) {
        err.message = "操作超时，请重试";
        throw nameError(err, ExceptionTypes.TimeoutError);
      }
      if (err.crossDomain) {
        err.message = "网络异常，请检查网络并重试。";
        throw nameError(err, ExceptionTypes.NetworkError);
      }
      if (err.status && err.response) {
        // 345 @see https://visionmedia.github.io/superagent/#error-handling
        const res = err.response;
        nameError(err, ExceptionTypes.HttpError);
        const techReason = (res.body || {}).message || res.statusText;
        err.message = "服务器异常" + (techReason ? `(${techReason})` : ""); // eslint-disable-line
        throw err;
      }
      err.message = `未知异常(${err.rawMessage})`;
      return nameError(err, ExceptionTypes.UnknownError);
    })
    .then(res => {
      const body = res.body;
      if (typeof body !== "object" || body === null) {
        const err = nameError(new Error("服务器异常(内容解析错误)"), ExceptionTypes.WrongBodyTypeError);
        err.response = res;
        throw err;
      }
      // @see <a href="http://wiki.sankuai.com/x/i82ELQ">Phx-状态码规范</a>
      if (body.status === BizCodes.UNAUTHORIZED) {
        throw _bizError(res, "您当前未登录或太长时间未操作，请刷新页面");
      }
      if (body.status > 0 && body.status < 2000 && body.status !== BizCodes.BAD_PARAMETER) {
        throw _bizError(res);
      }
      if (body.status > 0) {
        const err = _bizError(res);
        err.block = true; // block: 是否要阻塞业务
        if (body.redirect) err.redirect = body.redirect; // redirect: 跳转地址 之后看看是不是一定要这么用
        throw err;
      }
      return body.data;
    });
  // .catch(err => {
  //   /* Do something here to log error */
  //   throw err
  // })
  result.Request = sa;
  return result;
}

export function wrapGatewaySuperagent(sa) {
  const result = sa
    .catch(err => {
      err._message = err.message;
      if (err.name === "Error") {
        if (err.response) {
          err.message = (err.response.body || {}).message || err.response.statusText;
          const statusCode = err.response.status || -1;
          sendOwlAjaxError({
            name: "Ajax Error",
            statusCode,
            content: `${statusCode}: ${err.message}`,
          });
        } else {
          err.message = "网络异常，请检查网络";
          sendOwlAjaxError({
            name: "Ajax Error",
            statusCode: -1,
            content: err._message,
          });
        }
      }
      throw err;
    })
    .then(res => {
      const body = res.body;
      // 用于上报错误日志内容
      const content = `req: ${JSON.stringify(res.req._data || {})} res: ${res.text}`;
      // @see <a href="http://wiki.sankuai.com/x/i82ELQ">Phx-状态码规范</a>
      if (typeof body === "object" && body !== null) {
        // 用户未登录
        if (body.status === 401) {
          // @TODO: magic number
          const err = new Error("您当前未登录或太长时间未操作，请刷新页面");
          err.status = body.status;
          sendOwlAjaxError({
            name: res.req.url,
            statusCode: body.status,
            content,
          });
          throw err;
        }
        if (body.status > 0 && body.status < 2000 && body.status !== 301) {
          // @TODO magic number 301=参数错误
          const err = new Error(body.message);
          err.status = body.status;
          err.data = body.data;
          sendOwlAjaxError({
            name: res.req.url,
            statusCode: body.status,
            content,
          });
          throw err;
        }
        if (body.status > 0) {
          const err = new Error(body.message);
          err.status = body.status;
          err.data = body.data;
          err.block = true;
          sendOwlAjaxError({
            name: res.req.url,
            statusCode: body.status,
            content,
          });
          if (body.redirect) err.redirect = body.redirect;
          throw err;
        }
        return res;
      }
      const err = new Error("未知异常");
      err.status = -1;
      sendOwlAjaxError({
        name: res.req.url,
        statusCode: err.status,
        content,
      });
      throw err;
    });
  result.Request = sa;
  return result;
}
